import * as angular from 'angular';

import CoreModule from '../core/core.module';

import BuyerOfferImpactService from './buyer/buyerOfferImpact.service';
import { ImpactOverviewForBuyerComponent } from './buyer/impactOverviewForBuyer.component';
import { OfferImpactForBuyerComponent } from './buyer/offerImpactForBuyer.component';
import OptAllInModalService from './buyer/optAllInModal.service';
import OptAllSystemsInModalController from './buyer/optAllSystemsInModal.controller';
import { ImpactOverviewComponent } from './seller/impactOverview.component';
import { OfferImpactForSellerComponent } from './seller/offerImpactForSeller.component';
import FilterZeroSpendAndZeroSavingsFilter from './filterZeroSpendAndZeroSavings.filter';
import OfferImpactService from './OfferImpact.service';
import { SavingsDisplayComponent } from './common/savingsPuck/savingsDisplay.component';
import { SavingsPuckComponent } from './common/savingsPuck/savingsPuck.component';
import { SavingsPuckDetailsComponent } from './common/savingsPuck/savingsPuckDetails.component';
import { SavingsPuckFacilitiesComponent } from './common/savingsPuck/savingsPuckFacilities.component';
import { SavingsPuckRowsComponent } from './common/savingsPuck/savingsPuckRows.component';
import { SavingsHeaderAndControlsComponent } from './common/savingsHeaderAndControls.component';
import GraphsModule from '../../modules/graphs/graphs.module';

export default angular
  .module('offerImpact', [
    CoreModule,
    'aptitude', // for savings display directive
    GraphsModule
  ])
  .service('BuyerOfferImpact', BuyerOfferImpactService)
  .component('impactOverviewForBuyer', ImpactOverviewForBuyerComponent)
  .component('offerImpactForBuyer', OfferImpactForBuyerComponent)
  .service('OptAllInModal', OptAllInModalService)
  .controller('OptAllSystemsInModal', OptAllSystemsInModalController)
  .component('impactOverview', ImpactOverviewComponent)
  .component('offerImpactForSeller', OfferImpactForSellerComponent)
  .filter('filterZeroSpendAndZeroSavings', FilterZeroSpendAndZeroSavingsFilter)
  .service('OfferImpactService', OfferImpactService)
  .component('savingsDisplay', SavingsDisplayComponent)
  .component('savingsPuck', SavingsPuckComponent)
  .component('savingsPuckDetails', SavingsPuckDetailsComponent)
  .component('savingsPuckFacilities', SavingsPuckFacilitiesComponent)
  .component('savingsPuckRows', SavingsPuckRowsComponent)
  .component('savingsHeaderAndControls', SavingsHeaderAndControlsComponent)
  .name;
